import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { decryptPhoneNumber, handleJsonParse } from 'src/utils'

/** 다날 삼성페이 ISPAY: Bridge/새창에서 StartURL로 form POST */
const SamsungIsPay = () => {
  const [searchParams] = useSearchParams()
  const data = handleJsonParse(decryptPhoneNumber(searchParams.get('data')!))
  const { StartURL, TID, StartParams, OrderID } = data as {
    StartURL: string
    TID?: string
    StartParams?: string
    OrderID?: string
  }

  useEffect(() => {
    if (!StartURL) return

    const form = document.createElement('form')
    form.method = 'POST'
    form.action = StartURL
    form.acceptCharset = 'UTF-8'
    form.style.display = 'none'

    if (TID) {
      const tidInput = document.createElement('input')
      tidInput.type = 'hidden'
      tidInput.name = 'TID'
      tidInput.value = TID
      form.appendChild(tidInput)
    }

    // E2E와 동일: STARTPARAMS를 단일 필드로 전달
    if (StartParams) {
      const paramsInput = document.createElement('input')
      paramsInput.type = 'hidden'
      paramsInput.name = 'STARTPARAMS'
      paramsInput.value = StartParams
      form.appendChild(paramsInput)
    }

    document.body.appendChild(form)
    form.submit()
    form.remove()
  }, [StartURL, TID, StartParams, OrderID])

  return <></>
}

export default SamsungIsPay
